import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { DateService } from "@src/services";

export const useSevenDays = () => {
  const i18n = useI18n();

  const seven_days = computed(() => ({
    id: "7days",
    title: i18n.t("7 дней"),
    subtitle: DateService.formatLast7DaysRange(i18n.locale.value),
  }));

  return seven_days;
};
